module.exports = __webpack_public_path__ + "img/HKD.4f9c3035.png";